import L_HTML5 from "../assets/img/skills/html-5.svg";
import L_CSS3 from "../assets/img/skills/css3.svg";
import L_SASS from "../assets/img/skills/sass-1.svg";
import L_TAILWIND from "../assets/img/skills/tailwind.svg";
import L_BOOTSTRAP from "../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../assets/img/skills/react.svg";
import L_NEXTJS from "../assets/img/skills/nextjs.svg";
import L_REDUX from "../assets/img/skills/redux.svg";
import L_REACT_ROUTER from "../assets/img/skills/react-router.svg";
import L_MATERIALUI from "../assets/img/skills/material-ui-1.svg";
import L_TYPEORM from "../assets/img/skills/typeorm.png"
// import L_REACT_BOOTSTRAP from "../assets/img/skills/react-bootstrap.svg";
import L_STYLED_COMPONENTS from "../assets/img/skills/styled-components.svg";
import L_NODE_JS from "../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../assets/img/skills/express.svg";
import L_NESTJS from "../assets/img/skills/nestjs.svg";


import L_VBA from "../assets/img/skills/vba.webp";
// import L_DJANGO from "../assets/img/skills/django.svg";
// import L_FLASK from "../assets/img/skills/flask.svg";
import L_MONGODB from "../assets/img/skills/mongodb.svg";
import L_PHASER from "../assets/img/skills/phaser.svg";
// import L_POSTGRESQL from "../assets/img/skills/postgresql.svg";
// import L_MSSQL from "../assets/img/skills/mssql.svg";
import L_FIREBASE_DATABASE from "../assets/img/skills/firebase-realtime-database.png";
import L_MYSQL from "../assets/img/skills/mySql.svg";
import L_GIT from "../assets/img/skills/git-icon.svg";
import L_OVH from "../assets/img/skills/ovh.svg";

import L_FIREBASE_HOSTING from "../assets/img/skills/firebase-hosting.png";
import L_HEROKU from "../assets/img/skills/heroku.svg";
import L_DIGITAL_OCEAN from "../assets/img/skills/digital-ocean.svg";
import L_NETLIFY from "../assets/img/skills/netlify.svg";
import L_FIREBASE from "../assets/img/skills/firebase-icon.png";

import L_GITHUB_PAGES from "../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../assets/img/skills/javascript.svg";
import L_TYPESCRIPT from "../assets/img/skills/typescript.svg";
// import L_GOLANG from "../assets/img/skills/go-6.svg";
// import L_PYTHON from "../assets/img/skills/python.svg";

// --------------- TESTING
import L_REACT_TESTING_LIBRARY from "../assets/img/skills/react-testing-library.png"
import L_JEST from "../assets/img/skills/testing_jest.webp"
import L_CYPRESS from "../assets/img/skills/testing_cypress.png"
import L_MOCHA from "../assets/img/skills/testing_mocha.png"
import L_CHAI from "../assets/img/skills/testing_chai.png"

export const skills = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML 5",
      imgSrc: L_HTML5,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS 3",
      imgSrc: L_CSS3,
      skillName: "CSS3",
    },
    {
      link: "https://sass-lang.com/",
      imgAltText: "Sass",
      imgSrc: L_SASS,
      skillName: "Sass",
    },
    // {
    //   link: "https://webpack.js.org/",
    //   imgAltText: "Web-pack",
    //   imgSrc: L_WEBPACK,
    //   skillName: "Web-Pack",
    // },
    // {
    //   link: "https://www.javascript.com/",
    //   imgAltText: "JavaScript",
    //   imgSrc: L_JAVASCRIPT,
    //   skillName: "JavaScript",
    //   points: 152
    // },


    // {
    //   link: "https://reacttraining.com/react-router/",
    //   imgAltText: "React Router",
    //   imgSrc: L_REACT_ROUTER,
    //   skillName: "React Router",
    // },




    // {
    //   link: "https://react-bootstrap.github.io/",
    //   imgAltText: "React Bootstrap",
    //   imgSrc: L_REACT_BOOTSTRAP,
    //   skillName: "React Bootstrap",
    // },
    // {
    //   link: "https://nextjs.org/",
    //   imgAltText: "Next.js",
    //   imgSrc: L_NEXTJS,
    //   skillName: "Next.js",
    // },
    {
      link: "https://tailwindcss.com/",
      imgAltText: "Tailwind",
      imgSrc: L_TAILWIND,
      skillName: "Tailwind",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstrap",
      imgSrc: L_BOOTSTRAP,
      skillName: "Bootstrap",
    },
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: L_MATERIALUI,
      skillName: "Material-UI",
    },
    {
      link: "https://styled-components.com/",
      imgAltText: "styled-components",
      imgSrc: L_STYLED_COMPONENTS,
      skillName: "styled-components",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "React JS",
      imgSrc: L_REACT,
      skillName: "React JS",
      points: 110

    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: L_REDUX,
      skillName: "Redux Toolkit",
    },
  ],

  backend: [
    // {
    //   link: "https://pl.wikipedia.org/wiki/Visual_Basic_for_Applications",
    //   imgAltText: "VBA",
    //   imgSrc: L_VBA,
    //   skillName: "VBA",
    // },
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node.js",
      imgSrc: L_NODE_JS,
      skillName: "Node.js",
      points: 156
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: L_EXPRESS,
      skillName: "Express",
    }, {
      link: "https://nestjs.com/",
      imgAltText: "Nestjs",
      imgSrc: L_NESTJS,
      skillName: "NestJS",
    },
    // {
    //   link: "https://firebase.google.com/",
    //   imgAltText: "Firebase",
    //   imgSrc: L_FIREBASE,
    //   skillName: "Firebase",
    // },

    {
      link: "https://phaser.io/",
      imgAltText: "Phaser",
      imgSrc: L_PHASER,
      skillName: "Phaser",
    },
    // {
    //   link: "https://www.djangoproject.com/",
    //   imgAltText: "Django",
    //   imgSrc: L_DJANGO,
    //   skillName: "Django",
    // },
    // {
    //   link: "https://flask.palletsprojects.com/",
    //   imgAltText: "Flask",
    //   imgSrc: L_FLASK,
    //   skillName: "Flask",
    // },
  ],
  hostingPlatforms: [
    {
      link: "https://firebase.google.com/",
      imgAltText: "Firebase Hosting",
      imgSrc: L_FIREBASE_HOSTING,
      skillName: "Firebase Hosting",
    },
    {
      link: "https://www.ovh.com/",
      imgAltText: "Ovh",
      imgSrc: L_OVH,
      skillName: "OVH Cloud",
    },
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: L_HEROKU,
      skillName: "Heroku",
    },
    {
      link: "https://www.digitalocean.com/",
      imgAltText: "Digital Ocean",
      imgSrc: L_DIGITAL_OCEAN,
      skillName: "Digital Ocean",
    },
    {
      link: "https://www.netlify.com/",
      imgAltText: "Netlify",
      imgSrc: L_NETLIFY,
      skillName: "Netlify",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "GitHub Pages",
      imgSrc: L_GITHUB_PAGES,
      skillName: "GitHub Pages",
    },
  ],
  programmingLanguages: [
    {
      link: "https://www.javascript.com/",
      imgAltText: "JavaScript",
      imgSrc: L_JAVASCRIPT,
      skillName: "JavaScript",
    },
    {
      link: "https://www.typescriptlang.org/",
      imgAltText: "TypeScript",
      imgSrc: L_TYPESCRIPT,
      skillName: "TypeScript",
    },
    // {
    //   link: "https://www.python.org/",
    //   imgAltText: "Python",
    //   imgSrc: L_PYTHON,
    //   skillName: "Python",
    // },
    // {
    //   link: "https://golang.org/",
    //   imgAltText: "Golang",
    //   imgSrc: L_GOLANG,
    //   skillName: "Golang",
    // },
  ],
  databases: [
    // {
    //   link: "https://www.postgresql.org/",
    //   imgAltText: "PostgreSQL",
    //   imgSrc: L_POSTGRESQL,
    //   skillName: "PostgreSQL",
    // },
    // {
    //   link: "https://www.microsoft.com/en-us/sql-server/sql-server-2019",
    //   imgAltText: "MS-SQL",
    //   imgSrc: L_MSSQL,
    //   skillName: "MS-SQL",
    // },
    {
      link: "https://www.mysql.com/",
      imgAltText: "My-SQL",
      imgSrc: L_MYSQL,
      skillName: "My-SQL",
    },
    {
      link: "https://typeorm.io/",
      imgAltText: "TypeORM",
      imgSrc: L_TYPEORM,
      skillName: "TypeORM",
    },
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: L_MONGODB,
      skillName: "MongoDB",
    },
    {
      link: "https://firebase.google.com/",
      imgAltText: "Firebase Database",
      imgSrc: L_FIREBASE_DATABASE,
      skillName: "Firebase RealtimeDB",
    },
  ],
  versionControl: [
    {
      link: "https://git-scm.com/",
      imgAltText: "GIT",
      imgSrc: L_GIT,
      skillName: "GIT",
    },
  ],
  testing: [
    {
      link: "https://testing-library.com/docs/react-testing-library/intro/",
      imgAltText: "React Testing Library",
      imgSrc: L_REACT_TESTING_LIBRARY,
      skillName: "React Testing Library",
    },
    {
      link: "https://jestjs.io/",
      imgAltText: "JEST",
      imgSrc: L_JEST,
      skillName: "JEST",
    },
    {
      link: "https://www.cypress.io/",
      imgAltText: "Cypress",
      imgSrc: L_CYPRESS,
      skillName: "Cypress",
    },
    {
      link: "https://mochajs.org/",
      imgAltText: "Mocha",
      imgSrc: L_MOCHA,
      skillName: "MOCHA",
    },
    {
      link: "https://www.chaijs.com/",
      imgAltText: "Chai",
      imgSrc: L_CHAI,
      skillName: "Chai",
    }

  ]
}
